export default "__VITE_ASSET__BTl07t9D__"